import { render } from "./Valores.vue?vue&type=template&id=3b6e6b9c&scoped=true"
import script from "./Valores.vue?vue&type=script&lang=js"
export * from "./Valores.vue?vue&type=script&lang=js"

import "./Valores.vue?vue&type=style&index=0&id=3b6e6b9c&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6e6b9c"]])

export default __exports__